import { memo } from 'react';

import { X } from 'lucide-react';

import { Button } from '@/shadcn/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/shadcn/tooltip';

import { TestId } from '@/types/testId';

type Props = {
  index: number;
  value: string;
  removeValue: (index: number) => void;
};

/**
 * A single value element in the multiple values text area
 */
export const ValueLabel = memo(({ index, value, removeValue }: Props) => (
  <div className="m-1 flex flex-row flex-nowrap items-center gap-2 rounded-md bg-accent py-0.5 pr-1 pl-2 text-accent-foreground text-sm">
    {value}

    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className="hover:brightness-90"
            data-testid={TestId.ValueLabel.RemoveButton}
            onClick={() => removeValue(index)}
            size="smallIcon"
            variant="ghost"
          >
            <X size={15} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Remove email</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
));
